module.exports = __webpack_public_path__ + "static/media/10.57543ed6.jpg";